import { ConfirmDialog } from "primereact/confirmdialog";
import React from "react";
import CountdownTimer from "../CountdownTimer/CountdownTimer";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { SESSION_CONFIG, SUCCESS_LOGOUT} from "../../utilitties/constants";
import { apiLogout } from "../../services/logout.service";
import { STORAGE_LOCAL } from "../../models/storages";

export const TimeoutWarningModal = ({ isOpen, onRequestClose }) => {
    const onLogOffCall = async () => {
    const {data, status} = await apiLogout()
    if(status === 200){
      window.localStorage.removeItem(STORAGE_LOCAL.TOKEN);
      window.location.replace(data.nologin);
    }
  };
 

  const renderFooter = () => {
    return (
      <div className="p-d-flex p-flex-row-reverse p-ai-center flex-wrap">
        <div className="button-demo">
          <div className="template">
            <Button
              type="button"
              className="delete p-0"
              aria-label="Delete"
              onClick={onLogOffCall}
            >
              <i className="pi pi-sign-out px-2"></i>
              <span className="px-3">Cerrar sesión</span>
            </Button>

            <Button
              className="twitter p-0"
              aria-label="Twitter"
              onClick={onRequestClose}
            >
              <i className="pi pi-check px-2"></i>
              <span className="px-3">Permanecer conectado</span>
            </Button>
          </div>
        </div>
      </div>
    );
  };

  
  
  const NOW_IN_MS = new Date().getTime();
  const dateTimeAfterThreeDays = NOW_IN_MS + SESSION_CONFIG.SESSION_TIMEOUT_IN_MS;

  return (
    <Dialog
      header="Cierre de sesión Automática"
      visible={isOpen}
      style={{ width: "30vw" }}
      footer={renderFooter()}
      onHide={onRequestClose}
    >
      <div className="p-d-flex p-ai-center p-jc-center">
        <CountdownTimer targetDate={dateTimeAfterThreeDays} rateLimit={false} /> 
      </div>
      
    </Dialog>
  );
};

